import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20l10 -16","key":"svg-0"}],["path",{"d":"M7 12h10","key":"svg-1"}],["path",{"d":"M7 16h10","key":"svg-2"}],["path",{"d":"M17 20l-10 -16","key":"svg-3"}]]

const IconCurrencyNano = createReactComponent('outline', 'currency-nano', 'CurrencyNano', __iconNode);

export default IconCurrencyNano;